const BlockActionConditionDefault = {
    name : "Set Condition",
    action_type : {name : "condition"},
    type : { name : 'action'},
    data : {
        condition : ""
    },
    children : [
        {text: "Vrai", index : null, object_id : null, parent_block_id : null},
        {text: "Faux", index : null, object_id : null, parent_block_id : null},
    ],
}

const BlockActionConditionServerDefault = {
    name : "Set Condition",
    action_type : "condition",
    condition : ""
}

export { BlockActionConditionDefault , BlockActionConditionServerDefault }